import { Deserializable } from '../../deserializable';
import { ApplicantDto } from './applicant-dto.model';
import { PlaceholderDto } from './placeholder-dto.model';

export class PlaceholderListDto implements Deserializable {
  public Applicants: Array<ApplicantDto>;
  public Placeholders: Array<PlaceholderDto>;

  public deserialize(input: any): this {
    Object.assign(this, input);
    this.Applicants = input.Applicants
      ? input.Applicants.map((applicantDto: ApplicantDto) => new ApplicantDto().deserialize(applicantDto))
      : [];
    this.Placeholders = input.Placeholders
      ? input.Placeholders.map((placeholderDto: PlaceholderDto) => new PlaceholderDto().deserialize(placeholderDto))
      : [];

    return this;
  }
}
